import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.orbicabs';
const APP_STORE_URL = 'https://apps.apple.com/us/app/orbi-cabs/id6789555723';

function detectPlatform(userAgent = '') {
  const ua = userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'other';
}

export default function DownloadApp() {
  const platform = useMemo(
    () => detectPlatform(typeof navigator !== 'undefined' ? navigator.userAgent : ''),
    []
  );
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    const target =
      platform === 'ios' ? APP_STORE_URL : platform === 'android' ? PLAY_STORE_URL : null;

    if (!target) return undefined;

    setRedirected(true);
    const timer = window.setTimeout(() => {
      window.location.replace(target);
    }, 400);

    return () => window.clearTimeout(timer);
  }, [platform]);

  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        background: 'linear-gradient(180deg, #fffdf5 0%, #ffffff 55%)',
      }}
    >
      <div style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <h1 style={{ fontSize: 28, margin: '0 0 10px', color: '#1a1616' }}>Download Orbi Cabs</h1>
        <p style={{ color: '#6b6b6b', margin: '0 0 24px', lineHeight: 1.5 }}>
          {redirected
            ? 'Opening the right app store for your phone…'
            : 'Get the Orbi Cabs app to track your bookings.'}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <a
            href={PLAY_STORE_URL}
            style={{
              display: 'block',
              padding: '14px 18px',
              borderRadius: 10,
              background: '#FFC100',
              color: '#1a1616',
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Get it on Google Play
          </a>
          <a
            href={APP_STORE_URL}
            style={{
              display: 'block',
              padding: '14px 18px',
              borderRadius: 10,
              background: '#302B2B',
              color: '#fff',
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Download on the App Store
          </a>
          <Link to="/" style={{ marginTop: 8, color: '#6b6b6b', fontSize: 14 }}>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
